<div class="container">
    <br>
    <strong class="mb-1">Reference for {{citations_head}}</strong>
    <br>
    <hr>
    <br>
  
    <div class="target-component">
      <span> <h6>{{ title }}</h6></span>
      <hr>
      <span>
        <!-- <h5>Content :</h5> -->
        <br>
        <div class="scrollable-content">
              <markdown style="font-size: small;" [data]="contents" [disableSanitizer]="false"></markdown>
        </div>
      </span>
    </div>
  </div>
  
